import { ReactElement } from "react";
import { Link, To } from "react-router";
import { cn } from "@util/helpers";

export type CardMetaProps = {
  /** Optional additional styling for the container*/
  className?: string;
  /** Text to display */
  text: string;
  /** Link to page */
  to?: To;
};

/**  card meta example section link */
const CardMeta = ({
  className = "",
  text,
  to,
}: CardMetaProps): ReactElement => {
  const style = cn("typo-eyebrow uppercase hover:underline", className);

  if (typeof to === "undefined") {
    return (
      <div className={style} data-testid="card-meta-component">
        {text}
      </div>
    );
  }

  return (
    <div className={style} data-testid="card-meta-component">
      <Link to={to} title={text} reloadDocument>
        <span className="inline-block">{text}</span>
      </Link>
    </div>
  );
};

export default CardMeta;
